<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/LONNCZ/tc-custom/9781442495876.jpg?1730521899575" alt="This image is the cover for the book There Will Come a Time"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">There Will Come a Time
      </h1>
      <p class="bookDescription body article font2">
        <b>Mark grapples with the loss of his twin sister in this heart-wrenching novel of grief and resilience from National Book Award finalist Carrie Arcos.</b><br/><br/>Mark knows grief. Ever since the accident that killed his twin sister, Grace, the only time he feels at peace is when he visits the bridge where she died. Comfort is fleeting, but it’s almost within reach when he’s standing on the wrong side of the suicide bars. Almost.<br/><br/>Grace’s best friend, Hanna, says she understands what he’s going through. But she doesn’t. She can’t. It’s not just the enormity of his loss. As her twin, Mark should have known Grace as well as he knows himself. Yet when he reads her journal, it’s as if he didn’t know her at all.<br/><br/>As a way to remember Grace, Hanna convinces Mark to complete Grace’s bucket list from her journal. Mark’s sadness, anger, and his growing feelings for Hanna threaten to overwhelm him. But Mark can’t back out. He made a promise to honor Grace—and it’s his one chance to set things right.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Carrie Arcos
      </h2>
      
      <p class="authorDescription body article">Carrie Arcos is the author of <I>There Will Come a Time </I>and <I>Out of Reach</I>, which was a National Book Award Finalist. She lives with her family in Los Angeles, California. Visit her at CarrieArcos.com.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      S&S Books for Young Readers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?fffc4c62